import PropTypes from 'prop-types'
import { useState } from 'react'

import styles from '../SidebarControls.module.scss'

const SearchInput = ({ handleChange }) => {
  const [value, setValue] = useState('')

  function handleInputChange(e) {
    const { value } = e.target

    handleChange(value)
    setValue(value)
  }

  return (
    <>
      <input
        type="search"
        placeholder="Enter name or room no"
        value={value}
        onChange={handleInputChange}
        className={styles.searchInput}
      />
    </>
  )
}

SearchInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleClose: PropTypes.func
}

export default SearchInput
